export { default } from './life-category-item'
